// Shared helper — updates the cart icon bubble
function updateCartBubble(itemCount) {
  const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
  const countEl = bubble && bubble.querySelector('span[aria-hidden]');
  const labelEl = bubble && bubble.querySelector('span.visually-hidden');

  if (itemCount > 0 && bubble) {
    countEl.textContent = itemCount;
    labelEl.textContent = `${itemCount} item${itemCount === 1 ? '' : 's'}`;
  } else if (itemCount === 0 && bubble) {
    bubble.remove();
  }
}

function addToCartAjax(variantId, quantity = 1) {
  return fetch(theme.routes.cart_add_url + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity })
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === 422) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: { errorMessage: data.description }
        }));
      } else {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data }
        }));
        showCartNotification(data);
        fetch(`${theme.routes.cart_url}.js`)
          .then((r) => r.json())
          .then((cart) => updateCartBubble(cart.item_count));
      }
    })
    .catch((err) => console.error(err));
}


// Boost interception — capture phase, before Boost's own handler
document.addEventListener('click', (e) => {
  const boostBtn = e.target.closest('.boost-sd__button--select-option');
  if (!boostBtn) return;

  const metadata = boostBtn.getAttribute('data-metadata');
  if (!metadata) return;

  let parsed;
  try {
    parsed = JSON.parse(metadata);
  } catch {
    return;
  }

  const addToCartAction = parsed?.action?.addToCart;
  if (!addToCartAction) return; // let quickView / other actions pass through untouched

  e.preventDefault();
  e.stopImmediatePropagation(); // blocks Boost's own bubble-phase handler

  boostBtn.setAttribute('disabled', true);
  boostBtn.classList.add('loading');

  addToCartAjax(addToCartAction.productId).finally(() => {
    boostBtn.removeAttribute('disabled');
    boostBtn.classList.remove('loading');
  });
}, true); // capture: true — runs before Boost's bubble-phase listener

function showCartNotification(item) {
  const notif = document.getElementById('simple-cart-notification');
  if (!notif) return;

  const img = notif.querySelector('.simple-cart-notification__image');
  const title = notif.querySelector('.simple-cart-notification__title');

  if (item.image) {
    img.src = item.image;
    img.alt = ''; // decorative; title text already conveys the info
    img.hidden = false;
  } else {
    img.hidden = true;
  }
  title.textContent = item.product_title || item.title || '';

  notif.hidden = false;
  requestAnimationFrame(() => notif.classList.add('is-visible'));

  clearTimeout(notif._hideTimeout);
  // Pause dismissal on hover/focus so users have time to read or act
  notif._hideTimeout = setTimeout(() => hideCartNotification(), 6000);
}

function hideCartNotification() {
  const notif = document.getElementById('simple-cart-notification');
  if (!notif) return;
  notif.classList.remove('is-visible');
  setTimeout(() => { notif.hidden = true; }, 300);
}

document.addEventListener('DOMContentLoaded', () => {
  const notif = document.getElementById('simple-cart-notification');
  const closeBtn = document.querySelector('.simple-cart-notification__close');

  if (closeBtn) closeBtn.addEventListener('click', hideCartNotification);

  if (notif) {
    // Pause auto-dismiss while hovered or focused inside
    notif.addEventListener('mouseenter', () => clearTimeout(notif._hideTimeout));
    notif.addEventListener('focusin', () => clearTimeout(notif._hideTimeout));
    notif.addEventListener('mouseleave', () => {
      notif._hideTimeout = setTimeout(() => hideCartNotification(), 3000);
    });
  }
});


(function () {
  console.log('[carousel-fix] script loaded');

  function syncFocusability(container) {
  container.querySelectorAll('[aria-hidden]').forEach((el) => {
    // Skip elements already handled by the theme's own native fix
    if (el.matches('.slideshow__slide, .slideshow__box') || el.closest('.slideshow__slide, .slideshow__box')) {
      return;
    }

    const isHidden = el.getAttribute('aria-hidden') === 'true';
    const focusables = el.querySelectorAll('a, button, input, select, textarea, [tabindex]');
    focusables.forEach((focusable) => {
      if (isHidden) {
        if (!focusable.hasAttribute('data-original-tabindex')) {
          focusable.setAttribute(
            'data-original-tabindex',
            focusable.getAttribute('tabindex') || ''
          );
        }
        focusable.setAttribute('tabindex', '-1');
      } else if (focusable.hasAttribute('data-original-tabindex')) {
        const original = focusable.getAttribute('data-original-tabindex');
        if (original) {
          focusable.setAttribute('tabindex', original);
        } else {
          focusable.removeAttribute('tabindex');
        }
        focusable.removeAttribute('data-original-tabindex');
      }
    });
  });
}

function runSync() {
  syncFocusability(document.body);
}

  document.addEventListener('DOMContentLoaded', () => {
    console.log('[carousel-fix] DOMContentLoaded fired');
    runSync();
  });

  window.addEventListener('load', () => {
    console.log('[carousel-fix] window load fired');
    runSync();
    setTimeout(runSync, 500);
    setTimeout(runSync, 1500);
  });

  const observer = new MutationObserver((mutations) => {
    let shouldSync = false;
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        shouldSync = true;
      }
      if (mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length)) {
        shouldSync = true;
      }
    });
    if (shouldSync) {
      console.log('[carousel-fix] MutationObserver triggered a sync');
      runSync();
    }
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['aria-hidden'],
    childList: true,
    subtree: true
  });
  setInterval(runSync, 300);
window.__syncFocusability = runSync;
})();

(function () {
  function fixKlaviyoCloseButton(root) {
    root = root || document;
    root.querySelectorAll('img.needsclick[role="button"]').forEach(function (img) {
      if (!img.hasAttribute('alt')) {
        img.setAttribute('alt', '');
      }
      if (!img.getAttribute('aria-label')) {
        var labelText = img.getAttribute('label') || 'Close';
        img.setAttribute('aria-label', labelText);
      }
    });
  }

  fixKlaviyoCloseButton();

  var observer = new MutationObserver(function () {
    fixKlaviyoCloseButton();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

(function () {
  function fixSummaryLabels(root) {
    root = root || document;
    root.querySelectorAll('details > summary').forEach(function (summary) {
      if (summary.getAttribute('aria-label')) return; // already labeled

      var details = summary.closest('details');
      var titleEl = summary.querySelector('.accordion__title');
      var text = titleEl ? titleEl.textContent.trim() : summary.textContent.trim();

      if (!text && details && details.getAttribute('empty') === 'true') {
        // Fallback for the theme's known "no title" case
        text = 'Certified Pollinator Stewards';
      }

      if (text) {
        summary.setAttribute('aria-label', text);
      }
    });
  }

  fixSummaryLabels();

  var observer = new MutationObserver(function () {
    fixSummaryLabels();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

(function () {
  function fixSummaryTabindex(root) {
    root = root || document;
    root.querySelectorAll('details > summary[tabindex="-1"]').forEach(function (summary) {
      summary.removeAttribute('tabindex');
    });
  }

  fixSummaryTabindex();

  var observer = new MutationObserver(function () {
    fixSummaryTabindex();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

(function () {
  function fixReviewStarsNesting(root) {
    root = root || document;
    root.querySelectorAll('.jdgm-rev-widg__summary-stars[role="img"]').forEach(function (starsDiv) {
      // Remove the img role + label from the container since it holds a focusable link
      starsDiv.removeAttribute('role');
      starsDiv.removeAttribute('aria-label');

      // Hide the decorative star spans individually
      starsDiv.querySelectorAll('.jdgm-star').forEach(function (star) {
        star.setAttribute('aria-hidden', 'true');
      });
    });
  }

  fixReviewStarsNesting();

  var observer = new MutationObserver(function () {
    fixReviewStarsNesting();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

// Accessibility fix: font-size:0 leaves text invisible to sighted users
// but often still exposed to assistive tech — bump to a readable minimum
function fixZeroFontSize(root = document) {
  const elements = root.querySelectorAll('[style*="font-size:0"], [style*="font-size: 0"]');
  elements.forEach(el => {
    const computed = window.getComputedStyle(el).fontSize;
    if (computed === '0px') {
      el.style.setProperty('font-size', '12px', 'important');
    }
  });
}

// Initial pass
fixZeroFontSize();

// Catch dynamically injected elements (matches your existing MutationObserver pattern)
const fontSizeObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        fixZeroFontSize(node.parentElement || document);
      }
    });
  });
});

fontSizeObserver.observe(document.body, { childList: true, subtree: true });